import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { BannerLocationType } from '../enums/banner-location-type';

@Injectable({
  providedIn: 'root',
})
export class BannerLocationTypeProviderService {
  // prettier-ignore
  private readonly entries = new Map<BannerLocationType, string>([
    [BannerLocationType.HomePage, 'Slider strony głównej'],
    [BannerLocationType.SubscribePage, 'Slider subskrypcji'],
    [BannerLocationType.HomePageHeader, 'Slider strony głównej - nagłówek'],
    [BannerLocationType.SubscribePageHeader, 'Slider subskrypcji - nagłówek'],
  ]);

  public labelFor(location: BannerLocationType): Observable<string> {
    const entry = this.entries.get(location);

    if (isNil(entry)) {
      throw new EntryNotFoundException(
        `The entry for "${location}" code is not found.`,
      );
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<BannerLocationType>[]> {
    return this.selectItemsFor(Array.from(this.entries.keys()));
  }

  public selectItemsFor(
    locations: BannerLocationType[],
  ): Observable<SelectItem<BannerLocationType>[]> {
    return of(
      locations.map((location) => {
        const label = this.entries.get(location);

        if (isNil(label)) {
          throw new EntryNotFoundException(
            `The entry for "${location}" code is not found.`,
          );
        }

        return new SelectItem(label, location);
      }),
    );
  }
}
